module.exports = __webpack_public_path__ + "img/zhny32.f83187a6.svg";